// extracted by mini-css-extract-plugin
export default {"customTooltip":"customTooltipuAden","customBottomRightPlacement":"customBottomRightPlacementBHi89","textWrap":"textWrapEmrii"};